import { render } from "./ComponenteSimulaciones.vue?vue&type=template&id=a2460f24&scoped=true"
import script from "./ComponenteSimulaciones.vue?vue&type=script&lang=js"
export * from "./ComponenteSimulaciones.vue?vue&type=script&lang=js"

import "./ComponenteSimulaciones.vue?vue&type=style&index=0&id=a2460f24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2460f24"]])

export default __exports__